import RequestPageTwo from "./RequestPageTwo";

const SangaFund = () => {
    return (
        <RequestPageTwo title="Sanga Fund Request form"
            fetchUrl="/get-sangha-fund-requests"
            editEndpoint="update-sangha-fund-requests"
            deleteEndpoint="sangha-fund-requests"
            statusEndpoint="update-sangha-fund-requests" />
    );
}

export default SangaFund;
